import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

export const login = async (username, password) => {
  try {
    const response = await api.post('/auth', { username, password });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a Api.');
  }
};